import { apiCall } from '../helpers/apiHelpers';

export const agreementService = (sessionId) =>
  apiCall({
    method: 'GET',
    url: `/api/client/agreement?clientSessionId=${sessionId}`,
  })();
